import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const CustomerSettingsDiv = styled('div', { label: 'CustomerSettingsDiv' })`
    display: flex;
    margin-bottom: 5px;
`;

export const ContactPreferencesContainer = styled('div', { label: 'ContactPreferencesContainer' })`
    text-transform: capitalize;
`;

export const ContactPreferences = styled('div', { label: 'ContactPreferences' })`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
`;

export const ContactPreferencesHeader = styled('h4', { label: 'ContactPreferencesHeader' })`
    margin-top: 0;
`;

export const CustomerSettingsButton = styled('button', { label: 'CustomerSettingsButton' })`
    margin-right: 0px;
    flex: 1 1 0%;

    display: inline-block;
    border-radius: 3px;
    border: 1px solid #ccc;
    background: transparent;
    font-weight: bold;
    padding: 9px 15px;
    color: #888;
    font-size: 15px;
    vertical-align: middle;
    text-decoration: none;
    outline: none;
    line-height: 1;

    border-color: #ccc;
    cursor: pointer;

    &:disabled {
        background-color: #f5f5f5;
        color: #ccc;
        border-color: #e0e0e0;
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const SuccessMessage = styled('div', { label: 'SuccessMessage' })<{ size?: 'big' | 'small' }>`
    background-color: ${mainColors.status.success};
    border-radius: 2px;
    color: ${mainColors.default.light};
    font-size: 15px;
    padding: ${({ size }): string => (size === 'small' ? '0 8px' : '11px 8px 13px 8px')};
    text-align: center;
    margin-bottom: 5px;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    background: ${mainColors.status.error};
    color: white;
    font-weight: 600;
    padding: 5px 0 5px;
    text-align: center;
    margin-bottom: 5px;
`;

export const SelectWithPadding = styled('select', { label: 'SelectWithPadding' })`
    padding-top: 5px;
`;

